export default __webpack_public_path__ + "static/media/Print_certificate_Fr_2025_April.fde4554b.jpeg";